import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Card from '../common/Card';
import Table from '../common/Table';
import Button from '../common/Button';
import api from '../../services/api';
import { formatCurrency, formatDate } from '../../utils/formatters';

const StockMovements = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get('/inventory.php/movements');
      setRows(res.data.movements || res.data.transactions || []);
    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      key: 'created_at',
      label: 'Date',
      render: (v) => formatDate(v)
    },
    { key: 'product_name', label: 'Product' },
    { key: 'sku', label: 'SKU' },
    {
      key: 'transaction_type',
      label: 'Type',
      render: (v) => <span className={`status-badge ${v}`}>{v}</span>
    },
    { key: 'quantity', label: 'Qty' },
    {
      key: 'total_amount',
      label: 'Amount',
      render: (v) => formatCurrency(v)
    },
    {
      key: 'first_name',
      label: 'By',
      render: (_, row) => `${row.first_name || ''} ${row.last_name || ''}`.trim() || '—'
    }
  ];

  return (
    <div className="stock-movements-page">
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <h1>Stock Movements</h1>
          <p>Purchases, sales, adjustments and transfers</p>
        </div>
        <Link to="/products/low-stock">
          <Button variant="secondary">Low stock</Button>
        </Link>
      </div>
      <Card>
        <Table columns={columns} data={rows} loading={loading} />
      </Card>
    </div>
  );
};

export default StockMovements;
